import React from "react"
import { takeLatest, call, put } from "redux-saga/effects"

import axios from "axios"
import {
  GET_DIVISIONS_NO_PARENTS_WATCHER,
  CREATE_DIVISION_WATCHER,
} from "./constants"

import {
  getSubdivisionsWithoutParentSuccess,
  createDivisionSuccess,
  createDivisionFailed,
} from "./actions"

import {
  toggleCreateModal,
} from "../OrganizationPage/actions"

import { getDivisionsSaga } from "../Division/saga"
import { LOCAL_TOKEN } from "../../utils/storage"
import DOMPurify from "dompurify"

function messageProgress(messagex) {
  message.loading(messagex, 10000000000)
}

function messageSuccess(messagex) {
  const sanitizedHTML = DOMPurify.sanitize(messagex);
  message.success(
    <div
      className="messageAntd"
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />,
    5
  )
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

export function getSubdivisionsWithoutParentApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions/unassigned`,
  })
}

export function* getSubdivisionsWithoutParent() {
  try {
    const { data } = yield call(getSubdivisionsWithoutParentApi)
    yield put(getSubdivisionsWithoutParentSuccess(data))
  } catch (error) {}
}

export const createDivisionApi = (payload) => {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}divisions`,
    params: payload,
  })
}

export function* createDivisionSaga(action) {
  try {
    const { data } = yield call(createDivisionApi, action.payload)
    yield put(createDivisionSuccess())
    yield call(messageSuccess, data.data.msj)
    yield put(toggleCreateModal(false))
    yield call(getDivisionsSaga, { payload: "" })
  } catch (e) {
    console.log(e)
    yield put(createDivisionFailed())
    returnMessage(e)
  }
}
// Individual exports for testing
export default function* createDivisionModalSaga() {
  yield takeLatest(
    GET_DIVISIONS_NO_PARENTS_WATCHER,
    getSubdivisionsWithoutParent
  )
  yield takeLatest(CREATE_DIVISION_WATCHER, createDivisionSaga)
}
